module.exports = __webpack_public_path__ + "static/media/extraction.007c29f6.svg";